export default __webpack_public_path__ + "2f37fa693c991624d6dc65a1a46b0be7.png";